import modelBaseV2 from '../model-base-v2.model';

const getRandomPingList = (params) => {
  return modelBaseV2.get('/api/randomping/web/list', { params });
}
const getAvailableRecipients = (params) => {
  return modelBaseV2.get('/api/randomping/web/getavailablerecipients', { params });
}
const getRecipients = (params) => {
  return modelBaseV2.get('/api/randomping/web/pingdetailrecipientlist', { params });
}
const saveRandomPing = (body) => {
  return modelBaseV2.post('/api/randomping/web/addping', { body })
}
const getRandomPingDetail = (params) => {
  return modelBaseV2.get('/api/randomping/web/pingdetail/:randomPingHeader', { params });
}
const exportExcel = (params, fileName) => {
  return modelBaseV2.postDownload('/api/executesp/export/tr/file', { body: params }, fileName);
}

export {
  getRandomPingList,
  getAvailableRecipients,
  saveRandomPing,
  getRecipients,
  exportExcel,
  getRandomPingDetail
};